module.exports = __webpack_public_path__ + "img/p-3.21bf7927.jpg";